import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import './index.css'
import './registerServiceWorker'
// captura o beforeinstallprompt antes do app montar
import './install-prompt'

createApp(App).use(router).mount('#app')
